import { render } from "./ManageEvidence.vue?vue&type=template&id=a1d73bae&scoped=true"
import script from "./ManageEvidence.vue?vue&type=script&lang=js"
export * from "./ManageEvidence.vue?vue&type=script&lang=js"

import "./ManageEvidence.vue?vue&type=style&index=0&id=a1d73bae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d73bae"]])

export default __exports__